var exports = {
  "F": "x04b3a21e--2f992a--centered",
  "V": "x04b3a21e--2f992a--full-width",
};

module.exports = exports;
